<template>
  <div class="text-center">
    <v-dialog v-model="isShowDialog" width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-show="!isLogin" class="ma-2" color="primary" text v-bind="attrs" v-on="on">
          メンバーログイン
          <v-icon dark right> mdi-login </v-icon>
        </v-btn>
      </template>
      <v-card :loading="isLoading">
        <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
        <v-card-title class="ma-0 pa-5 justify-center text-h6"> メンバーログイン </v-card-title>
        <v-card-subtitle class="mx-10 pa-0 text-left">
          <p class="my-2 pa-0 text-body-2">
            ダイブセンターまたはメンバーの方はログイン<br />してください。
          </p>
          <div class="d-flex flex-row align-baseline" width="60%">
            <v-text-field v-model="loginId" label="ログインID" required></v-text-field>
          </div>
          <div class="d-flex flex-row align-baseline" width="60%">
            <v-text-field
              type="password"
              v-model="password"
              label="パスワード"
              required
            ></v-text-field>
          </div>
          <p class="ma-0 pa-0 text-body-2 red--text">{{ this.errorLogin }}</p>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeDialog" class="mx-2"> キャンセル </v-btn>
          <v-btn color="primary" depressed @click="login" class="mx-2">ログイン </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import defaultValues from 'constant/login-form/default-values';

export default {
  computed: {
    /**
     * 認証状態を取得する
     */
    isLogin: {
      cache: false,
      get() {
        return this.$store.getters['partner/isAuthenticated'];
      },
    },
  },
  created() {
    this.resetInputForm();
  },
  data() {
    return {
      errorLogin: '',
      isShowDialog: false,
      loginId: null,
      password: null,
      isLoading: false,
    };
  },
  methods: {
    /**
     * ダイアログを閉じる
     */
    closeDialog: function () {
      // ダイアログを非表示にする
      this.isShowDialog = false;
      this.resetInputForm();
    },
    /**
     * ログインする
     */
    login: async function () {
      this.isLoading = true;
      try {
        let res = await this.$store.dispatch('partner/signin', {
          loginId: this.loginId,
          password: this.password,
        });
        // console.log(`res:${JSON.stringify(res)}`);
        if (res.success) {
          // パートナー情報を取得する
          res = await this.$store.dispatch('partner/getPartner');

          if (res.success) {
            // パートナー情報を注文情報にセットする
            const partner = this.$store.getters['partner/partner'];
            this.$store.commit('shoppingOrder/setApplicationUsingPartner', partner);

            // 商品カテゴリ一覧を取得する
            await this.$store.dispatch('productCategory/getProductCategories');
            // 商品一覧を取得する
            await this.$store.dispatch('product/getProducts');
            // ダイアログを非表示にする
            this.closeDialog();
          } else {
            this.errorLogin = res.message;
            await this.$store.dispatch('partner/signout');
          }
        } else {
          this.errorLogin = res.message;
        }
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 入力内容を初期化する
     */
    resetInputForm: function () {
      // 入力内容を初期化する
      if (process.env.RAILS_ENV === 'development') {
        // テスト用データをセットする
        defaultValues.setTestUser();
      }
      this.loginId = defaultValues.loginId;
      this.password = defaultValues.password;
      // エラー表示項目を初期化する
      this.errorLogin = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
</style>
